<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader class="font-weight-bold catalogo-text"
            >Inventario Actual</CCardHeader
          >
          <CCardBody>
            <CRow class="mb-3">
              <CCol md="6" lg="6">
                <label>Almacén:</label>
                <v-select
                  v-model="almacen"
                  :options="almacenes"
                  :loading="isLoading"
                  @input="actualizarInfo()"
                  class="margin-multi"
                  placeholder="Selecciona un almacén"
                >
                  <template #open-indicator="{ attributes }">
                    <CIcon
                      v-bind="attributes"
                      class="cursor-p"
                      name="cil-caret-bottom"
                    />
                  </template>
                  <template #no-options>
                    Sin resultados.
                  </template>
                </v-select>
              </CCol>
            </CRow>
            <CRow class="mb-3">
              <CCol md="6" lg="6">
                <template>
                  <CInput
                    :disabled="almacen ? false : ''"
                    v-model="filter"
                    @input="searchTimeOut()"
                    placeholder="Búsqueda..."
                  />
                </template>
              </CCol>
            </CRow>
            <div
              class="w-100 d-flex justify-content-center align-items-center"
              v-if="isLoading"
            >
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
            <CDataTable
              v-else
              hover
              bordered
              small
              fixed
              :loading="isLoading"
              :items="items"
              :fields="fields"
              :noItemsView="noItems"
            >
              <template #ALMACEN_NOMBRE="{item}">
                <td class="py-2">{{ item.almacen }}</td>
              </template>
              <template #CATEGORIA="{item}">
                <td class="py-2">{{ item.categoria }}</td>
              </template>
              <template #PRODUCTO_NOMBRE="{item}">
                <td class="py-2">
                  <router-link
                    :to="{
                      name: 'InventarioDetallado',
                      params: {
                        producto: item.producto,
                        almacen: almacen
                      }
                    }"
                  >
                    {{ item.producto }}
                  </router-link>
                </td>
              </template>
              <template #CANTIDAD="{item}">
                <td class="py-2 text-right">
                  {{ $formatterNumber(item.existencia_actual, 4) }}
                </td>
              </template>
              <template #COSTO="{item}">
                <td class="py-2 text-right">
                  {{ $formatter(item.costo_total, true) }}
                </td>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
const fields = [
  { key: "ALMACEN_NOMBRE", label: "Almacén", _style: "width:10%" },
  { key: "CATEGORIA", label: "Categoría", _style: "width:10%" },
  { key: "PRODUCTO_NOMBRE", label: "Producto Nombre", _style: "width:10%" },
  {
    key: "CANTIDAD",
    label: "Existencia Actual",
    _style: "width:10%; text-align: center"
  },
  {
    key: "COSTO",
    label: "Costo Total",
    _style: "width:10%; text-align: center"
  }
];

export default {
  name: "InventarioActual",

  components: {
    vSelect
  },

  data() {
    return {
      items: [],
      config: this.$route.params.almacen,
      fields,
      filter: "",
      isLoading: false,
      almacen: null,
      almacenes: [],
      almacenesAll: [],
      page: 1,
      pages: 1,
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" }
    };
  },

  created() {
    this.almacen = this.config;
    this.actualizarInfo();
  },

  computed: {
    clave_empresa() {
      return this.$store.state.clave_empresa.toUpperCase();
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  watch: {
    ubicacionRaiz: function() {
      this.actualizarInfo();
    }
  },

  methods: {
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(() => {
        this.actualizarInfo();
      }, 800);
    },
    actualizarInfo() {
      this.isLoading = true;

      let template = {
        body: {
          reporte: "saldos_concentrado",
          params: {
            ubicaciones: [this.ubicacionRaiz]
          }
        }
      };

      this.almacen
        ? (template = {
            ...template,
            body: {
              ...template.body,
              params: {
                ...template.body.params,
                almacen_id: this.almacen.value
              }
            }
          })
        : null;

      this.filter != ""
        ? (template = {
            ...template,
            body: {
              ...template.body,
              params: {
                ...template.body.params,
                producto_ruta_nombre: this.filter
              }
            }
          })
        : null;

      const balance = [];

      balance.push(
        this.$store.dispatch("customHTTP", {
          schema: "almacenes",
          filter: {
            wherein: [
              {
                field: "payload->ubicacion_id",
                value: [this.ubicacionRaiz]
              }
            ]
          }
        })
      );

      if (this.almacen) {
        balance.push(this.$store.dispatch("customIndicadoresHTTP", template));
      }

      Promise.all(balance)
        .then(([almacenes, saldos]) => {
          this.items = saldos != null ? saldos.data : null;

          this.almacenes = almacenes.data.map(almacen => {
            return { value: almacen.id, label: almacen.payload.nombre };
          });
          this.almacenesAll = almacenes.data;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.cursor-p {
  cursor: pointer;
}
</style>
